import { Entity } from "src/app/shared/models/entity";
import { ValueTextPair } from "src/app/shared/models/value-text-pair";
import { Clinic } from "src/app/system/clinic/models/clinic";
import { SystemAnnouncement } from "src/app/system/system-announcement/models/SystemAnnouncement";
import { DataScopeEnum } from "src/app/enums/DataScopeEnum";

export class Announcement extends Entity{
    CompanyId:number;
    /**公告類型 */
    TypeCode:string;
    /**公告分類 */
    ClassCode:string;
    /** 標題 */
    Title:string;
    /** 內容 */
    Content:string;
    /** 起始時間 */
    StartTime:Date;
    /** 結束時間 */
    EndTime:Date;
    /** 警示時機 */
    AlertOn:string;
    Targets:AnnouncementGroup[];
}
export class AnnouncementListDto{
    Id:number;
    CompanyId:number;
    /**公告類型 */
    TypeCode:string;
    /**公告分類 */
    ClassCode:string;
    /** 標題 */
    Title:string;
    /** 內容 */
    Content:string;
    /** 起始時間 */
    StartTime:Date;
    /** 結束時間 */
    EndTime:Date;
    FileCount:string;
    /** 警示時機 */
    AlertOn:string;
    Targets:AnnouncementGroup[];
}
export class AnnouncementGroup extends Entity{
    Name:string;
    Members:Clinic[]
    Announcement:SystemAnnouncement[];
}

export interface AnnouncementGroupDto {
    Id: number;
    Name: string;
    Members: ClinicMemberDto[];
    MemberCount: number;
    IsDefault?: boolean;
}

export interface ClinicMemberDto {
    Id: number;
    Code: string;
    Name: string;
    NHICode: string;
    NHILevel: string;
    NHIType: number;
    Type: number;
    City: string;
    Area: string;
    Street: string;
    FullAddress: string;
    MedDeptCode: string;
    Phone: string;
    IsSelected: boolean;
}

export interface AnnouncementWithTargetDto {
    Id: number;
    CompanyId: number;
    TypeCode: string;
    ClassCode: string;
    Title: string;
    Content: string;
    AlertOn: string;
    StartTime: Date;
    EndTime: Date;
    CreateTime?: Date;
    Creater: string;
    EditTime?: Date;
    Editer: string;
    IsEnabled: boolean;
    Target: AnnouncementGroupDto[];
}

export interface ChiMedSelecterGridItemOption {
    StdCode: string;
    ProdName: string;
    Manu: string;
}

export interface ChiMedSelecterGridItemDto {
    Code: string;
    StdCode: string;
    ProdName: string;
    Formula: string;
    Manu: string;
    EndDate: Date | null;
    Options?: ChiMedSelecterGridItemOption[];
    Price:number;
    IPrice:number;
    CustomerCost:number;
}
export interface ChiMedSelecterUpdateItemDto{
    Code: string;
    StdCode: string;
    StdCode2: string;
    Price?:number;
    IPrice?:number;
    CustomerCost?:number;
}
export interface GetAllQueryDto {
    ClinicId?: number;
    TypeCode?: string;
    ClassCode?: string;
    StartTime?: Date | string;
    EndTime?: Date | string;
    Title?: string;
    Mode?: string;
    DataScope?: DataScopeEnum;
    OrderDesc?: boolean;
    pageSize: number;
    pageSkipNo: number;
    pageSkip: number;
}

export interface ChiMedExpireData {
  EndDate: Date;
  StdCodes: string;
}
